<template>
    <a-layout class="help-detail">
        <a-layout-header>
            <page-nav></page-nav>
        </a-layout-header>
        <a-layout-content class="help-detail__body">
            <main class="help-detail__inner announcement-detail">
                <button type="button" class="help-detail__back" @click="$router.push('/help')">
                    <icon-left size="18" />
                    <span>{{ $t('help_pages.back_to_help') }}</span>
                </button>
                <h1>{{ $t('help_pages.announcement.title') }}</h1>
                <p class="announcement-detail__lead">{{ $t('help_pages.announcement.lead') }}</p>
                <article class="announcement-detail__article">
                    <h2>{{ $t('help_pages.announcement.overview_title') }}</h2>
                    <p>{{ $t('help_pages.announcement.overview') }}</p>
                    <h2>{{ $t('help_pages.announcement.reasons_title') }}</h2>
                    <p>{{ $t('help_pages.announcement.reasons') }}</p>
                    <h2>{{ $t('help_pages.announcement.convenience_title') }}</h2>
                    <p>{{ $t('help_pages.announcement.convenience') }}</p>
                    <h2>{{ $t('help_pages.announcement.diversity_title') }}</h2>
                    <p>{{ $t('help_pages.announcement.diversity') }}</p>
                    <h2>{{ $t('help_pages.announcement.tools_title') }}</h2>
                    <p>{{ $t('help_pages.announcement.tools') }}</p>
                    <h2>{{ $t('help_pages.announcement.summary_title') }}</h2>
                    <p>{{ $t('help_pages.announcement.summary') }}</p>
                    <p class="announcement-detail__tagline">{{ $t('help_pages.announcement.tagline') }}</p>
                </article>
            </main>
        </a-layout-content>
        <a-layout-footer>
            <Footer></Footer>
        </a-layout-footer>
    </a-layout>
</template>

<script>
import PageNav from "@/components/PageNav/PageNav.vue";
import Footer from "@/components/Footer/footer.vue";

export default {
    components: {
        PageNav,
        Footer
    }
};
</script>

<style lang="scss" scoped>
.help-detail,
.help-detail__body {
    background: var(--background-primary);
}

.help-detail__body {
    min-height: 620px;
    padding: 48px 24px 88px;
    box-sizing: border-box;
}

.help-detail__inner {
    width: min(100%, 960px);
    margin: 0 auto;
}

.help-detail__back {
    padding: 0;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    border: 0;
    background: transparent;
    color: var(--content-secondary);
    font-size: 14px;
    cursor: pointer;
}

.help-detail__back:hover {
    color: var(--color-primary);
}

.help-detail h1 {
    margin: 34px 0 12px;
    color: var(--content-primary);
    font-size: 36px;
    line-height: 1.35;
}

.announcement-detail__lead,
.announcement-detail__article p {
    color: var(--content-secondary);
    font-size: 16px;
    line-height: 1.85;
    white-space: pre-line;
    overflow-wrap: anywhere;
}

.announcement-detail__lead {
    margin: 0 0 36px;
}

.announcement-detail__article {
    border-top: 1px solid var(--border-strength-100);
}

.announcement-detail__article h2 {
    margin: 34px 0 10px;
    color: var(--content-primary);
    font-size: 21px;
    line-height: 1.5;
}

.announcement-detail__article p {
    margin: 0;
}

.announcement-detail__tagline {
    margin-top: 36px !important;
    color: var(--color-primary) !important;
    font-weight: 600;
}

@media (max-width: 768px) {
    .help-detail__body {
        padding: 34px 20px 64px;
    }

    .help-detail h1 {
        font-size: 28px;
    }

    .announcement-detail__lead,
    .announcement-detail__article p {
        font-size: 15px;
    }
}
</style>
